import { loadBookingConfirmedPage } from './pages/booking-confirmed';
import { loadChooseServicesPage } from './pages/choose-services';
import { BookingContext } from '../util/booking-context';
import { getCookie } from '../util/cookie';
import { hideLoadingOverlay, showLoadingOverlay } from '../util/loading-overlay';
import { log } from '../util/log';
import { track } from '../util/tracking';
import { loadSelectLocationPage } from './pages/select-location';
import { callWp } from '../util/call-wp';

document.addEventListener('DOMContentLoaded', loadBookingPage);

const SELECTOR_ROOT_ELEMENT = '.wp-block-silk-nexus-wp-plugin-make-booking';
const SELECTOR_ROOT_CONTEXT_ELEMENT = '.wp-block-silk-nexus-wp-plugin-make-booking .booking-content';
// const SELECTOR_LOADER_ELEMENT = '.wp-block-silk-nexus-wp-plugin-make-booking .booking-loading-overlay';

async function loadBookingPage() {
	// @ts-ignore
	if (!window.bootstrap) {
		// @ts-ignore
		window.bootstrap = {
			// @ts-ignore
			Modal: window.Modal,
		};
	}

	const root = document.querySelector<HTMLElement>(SELECTOR_ROOT_CONTEXT_ELEMENT);
	if (!root) {
		log('Booking element not found');
		return;
	}

	// get the categories from the backend
	const categories = await callWp('GET', 'get_service_categories');
	if (!categories) {
		alert('An unexpected error occurred. Please try again later.');
		window.location.href = '/';
		return;
	}
	window.serviceCategories = categories;

	// const clinicSelectorBar = document.querySelector('.clinic-location');
	// if (clinicSelectorBar) {
	// 	clinicSelectorBar.remove();
	// }

	const context: BookingContext = {
		root,
		data: {
			skinType: null,
			locationId: null,
			locationName: null,
			serviceIds: [],
			addonIds: [],
			date: null,
			serviceBookingId: null,
			slotTime: null,
			includeConsult: null,
			safetyPass: null,
			firstTime: null,
			serviceData: new Map(),
			addonData: new Map(),
			consultData: new Map(),
			categoryId: null,
			categoryName: null,
			subcategoryId: null,
			subcategoryName: null,
			rebook: false,
			skipDeposit: false,
			book: false,
			reschedule: false,
			invoiceId: null,
			displayDate: null,
			displayTime: null,
			goToTimeslots: false,
			injectQuestionCompleted: false,
			therapistId: null,
			continueBooking: false,
			categoryParam: null,
			subcategoryParam: null,
		},
	};

	// {
	// 	// Check if the user is activated
	// 	const userIsActivated = await callWp('GET', 'is_user_ready');
	// 	if (!userIsActivated?.success === true) {
	// 		alert('An unexpected error occurred. Please try again later.');
	// 		window.location.href = silkNexusWp.myAccountUrl;
	// 		return;
	// 	}

	// 	// User must be verified
	// 	if (userIsActivated.verified !== true) {
	// 		window.location.href = `${silkNexusWp.myAccountUrl}?require_verification=1`;
	// 		return;
	// 	}

	// 	// And their account must be linked in nexus
	// 	if (userIsActivated.linked !== true) {
	// 		alert('We are still setting up your online account. Please try again later. Alternatively, contact a clinic to make your booking.');
	// 		window.location.href = silkNexusWp.myAccountUrl;
	// 		return;
	// 	}
	// }

	const goToTimeslots = new URLSearchParams(window.location.search).get('goToTimeslots');
	if (goToTimeslots === 'true') {
		const serviceIdsString = new URLSearchParams(window.location.search).get('serviceIds');
		const addonIdsString = new URLSearchParams(window.location.search).get('addonIds');
		const locationIdString = new URLSearchParams(window.location.search).get('locationId');

		if (!locationIdString) {
			return;
		}

		const serviceIds: string[] = [];
		const addonIds: string[] = [];
		const locationId = parseInt(locationIdString);

		if (serviceIdsString) {
			serviceIdsString.split(',').forEach((id) => serviceIds.push(id));
		}

		if (addonIdsString) {
			addonIdsString.split(',').forEach((id) => addonIds.push(id));
		}

		context.data.goToTimeslots = true;
		context.data.locationId = locationId;
		context.data.serviceIds = serviceIds;
		context.data.addonIds = addonIds;
	}

	// If we are resccheduling, get the invoice id, service ids, and addon ids, and location id
	const reschedule = new URLSearchParams(window.location.search).get('reschedule');
	if (reschedule === 'true') {
		const serviceIdsString = new URLSearchParams(window.location.search).get('serviceIds');
		const addonIdsString = new URLSearchParams(window.location.search).get('addonIds');
		const locationIdString = new URLSearchParams(window.location.search).get('locationId');
		const invoiceIdString = new URLSearchParams(window.location.search).get('invoiceId');

		if (!locationIdString) {
			return;
		}

		const serviceIds: string[] = [];
		const addonIds: string[] = [];

		if (serviceIdsString) {
			serviceIdsString.split(',').forEach((id) => serviceIds.push(id));
		}

		if (addonIdsString) {
			addonIdsString.split(',').forEach((id) => addonIds.push(id));
		}

		context.data.reschedule = true;
		context.data.locationId = parseInt(locationIdString);
		context.data.serviceIds = serviceIds;
		context.data.addonIds = addonIds;
		context.data.invoiceId = invoiceIdString;

		return loadChooseServicesPage(context);
	}

	const categoryParamVal = new URLSearchParams(window.location.search).get('category');
	const subcategoryParamVal = new URLSearchParams(window.location.search).get('subcategory');
	if (categoryParamVal) {
		context.data.categoryParam = categoryParamVal;
		if (subcategoryParamVal){
			context.data.subcategoryParam = subcategoryParamVal;
		}
	}

	// If we are rebooking, get the rebook, service and addon ids, and location id
	const rebook = new URLSearchParams(window.location.search).get('rebook');
	if (rebook === 'true') {
		const serviceIdsString = new URLSearchParams(window.location.search).get('serviceIds');
		const addonIdsString = new URLSearchParams(window.location.search).get('addonIds');
		const locationIdString = new URLSearchParams(window.location.search).get('locationId');

		if (!locationIdString) {
			return;
		}

		const serviceIds: string[] = [];
		const addonIds: string[] = [];
		const locationId = parseInt(locationIdString);

		if (serviceIdsString) {
			serviceIdsString.split(',').forEach((id) => serviceIds.push(id));
		}

		if (addonIdsString) {
			addonIdsString.split(',').forEach((id) => addonIds.push(id));
		}

		context.data.rebook = true;
		context.data.locationId = locationId;
		context.data.serviceIds = serviceIds;
		context.data.addonIds = addonIds;

		return loadChooseServicesPage(context);
	}

	// If we are rebooking, get the rebook, service and addon ids, and location id
	const book = new URLSearchParams(window.location.search).get('book');
	if (book === 'true') {
		const serviceIdsString = new URLSearchParams(window.location.search).get('serviceIds');
		const addonIdsString = new URLSearchParams(window.location.search).get('addonIds');
		const locationIdString = new URLSearchParams(window.location.search).get('locationId');
		const firstTime = new URLSearchParams(window.location.search).get('firstTime') === '1';

		if (!locationIdString) {
			log('No location id');
			return;
		}

		const serviceIds: string[] = [];
		const addonIds: string[] = [];
		const locationId = parseInt(locationIdString);

		if (serviceIdsString) {
			serviceIdsString.split(',').forEach((id) => serviceIds.push(id));
		}

		if (addonIdsString) {
			addonIdsString.split(',').forEach((id) => addonIds.push(id));
		}

		context.data.book = true;
		context.data.locationId = locationId;
		context.data.serviceIds = serviceIds;
		context.data.addonIds = addonIds;
		context.data.includeConsult = firstTime;
		context.data.firstTime = firstTime;

		log('book');

		return loadChooseServicesPage(context);
	}

	// Get the serviceBookingId from the url if it exists (this is for the booking confirmed page)
	const serviceBookingId = new URLSearchParams(window.location.search).get('serviceBookingId');
	if (serviceBookingId) {
		log('serviceBookingId: ', serviceBookingId);
		const success = new URLSearchParams(window.location.search).get('success') === 'true';

		if (success) {
			context.data.serviceBookingId = serviceBookingId;
			return loadBookingConfirmedPage(context);
		}

		alert('There was an error with confirming your booking. Please contact your clinic to try again.');
	}

	//
	// Try to load the saved booking data from the local storage
	//
	const localStorageKey = 'silk-nexus-wp-booking-data';
	const localStorageData = localStorage.getItem(localStorageKey);

	if (localStorageData) {
		const data = JSON.parse(localStorageData);

		console.log('Local Storage Data: ', data);

		if (data) {
			const { locationId, serviceIds, addonIds, includeConsult } = data;
			console.log('locationId !== undefined', locationId !== undefined);
			console.log('serviceIds !== undefined', serviceIds !== undefined);
			console.log('addonIds !== undefined', addonIds !== undefined);
			console.log('includeConsult !== undefined', includeConsult !== undefined);
			// console.log('locationId === context.data.locationId', locationId === context.data.locationId);

			// if these are all not undefined
			if (
				locationId !== undefined &&
				serviceIds !== undefined &&
				addonIds !== undefined &&
				includeConsult !== undefined
				// and the location is the same as the current location
				// locationId === context.data.locationId
			) {
				console.log('continue booking');

				context.data.goToTimeslots = true;
				context.data.continueBooking = true;
				context.data.locationId = locationId;
				context.data.serviceIds = serviceIds;
				context.data.addonIds = addonIds;
				context.data.includeConsult = includeConsult;

				loadChooseServicesPage(context);
				return;
			}
		}
	} else {
		console.log('No local storage data');
	}

	//
	//
	// Location

	function getLocationModal(): HTMLElement {
		// @ts-ignore
		return document.getElementById('locationModal');
	}

	const selectClinic = (clinic: { id: number; name: string } | null) => {
		getLocationModal()?.removeEventListener('hidden.bs.modal', () => loadLocation());
		// Check if the clinic is zenoti enabled, if it is not, then redirect to the old booking system
		if (clinic === null) {
			return;
		}

		log('Clinic: ', clinic);

		context.data.locationId = clinic.id;
		context.data.locationName = clinic.name;

		const clinicName = document.querySelector<HTMLSpanElement>('#locationConfirmModal [data-clinic-name]');
		if (clinicName) {
			clinicName.innerText = clinic.name;
		}

		loadChooseServicesPage(context);
	};

	type LocationChangedEvent = CustomEvent & {
		detail: {
			id: number;
			name: string;
		};
	};

	function handleLocationChange(e: Event) {
		const event = e as LocationChangedEvent;
		const clinic = event.detail;

		context.data.locationId = clinic.id;
		context.data.locationName = clinic.name;

		selectClinic(clinic);
	}
	document.addEventListener('locationchange', handleLocationChange);

	// ! Always force the modal to open ! Silk requested this

	// loadSelectLocationPage(context);
	// return;

	async function loadLocation(redirect = false) {
		// Try to load the location id from the cookies
		const locationId = getCookie('location_id') ?? '';
		const locationName = decodeURIComponent(getCookie('location')) ?? '';

		const brand = (document.querySelector(SELECTOR_ROOT_ELEMENT) as HTMLElement)?.dataset.brand ?? '';

		if (locationId) {
			// Create a bootstrap modal that cannot be dismissed for the location name. If 'Next' is pressed, select the clinic. If 'Choose another clinic' is selected, then show the location modal

			const modalHTML = `
            <div class="modal fade" id="locationConfirmModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true" data-brand="${brand}">
                <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="padding: 2rem; max-width: 28rem">
                    <div class="modal-body mb-3 p-0 d-flex flex-column align-items-center justify-content-center text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 512 512" style="margin-bottom: 1rem"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>
                    <span>You are booking at</span>
                    <span data-clinic-name style="font-size: 2rem; font-weight: 500">${locationName}</span>
                    </div>
                    <div class="d-flex flex-column gap-2">
                    <button type="button" class="btn btn-primary text-white" style="font-weight: 700; font-size: 0.875rem">CONTINUE</button>
                    <button type="button" class="btn btn-black text-white" style="font-weight: 700; font-size: 0.875rem" data-bs-dismiss="modal">CHOOSE ANOTHER CLINIC</button>
                    </div>
                </div>
                </div>
            </div>
            <style>.theme-tcc #locationConfirmModal .btn-black.text-white{color:#0a0a0a!important;margin-top:.5rem}</style>
            `;
			document.body.insertAdjacentHTML('beforeend', modalHTML);

			const modalElement = document.getElementById('locationConfirmModal')!;
			const modal = new window.bootstrap.Modal(modalElement, {
				backdrop: 'static',
				keyboard: false,
			});

			const chooseAnotherClinicButton = modalElement.querySelector<HTMLButtonElement>('.btn-black')!;
			chooseAnotherClinicButton.addEventListener('click', () => {
				modal.hide();
			});

			// on dismiss, show location modal
			// data-bs-dismiss
			modalElement.querySelector<HTMLButtonElement>('.btn-black')!.addEventListener('click', async () => {
				// @ts-ignore
				await showLocationModal();
				getLocationModal()?.addEventListener('hidden.bs.modal', () => loadLocation());
			});

			// on next, select clinic
			modalElement.querySelector<HTMLButtonElement>('.btn-primary')!.addEventListener('click', () => {
				selectClinic({
					id: parseInt(locationId),
					name: locationName,
				});
				modal.hide();
			});

			modal.show();
			return;
		}

		if (redirect) {
			window.location.href = document.body.dataset.directoryUrl ?? '/';
			return;
		}

		// @ts-ignore
		await showLocationModal();
		getLocationModal()?.addEventListener('hidden.bs.modal', () => loadLocation(true));
	}

	loadLocation();

	// selectClinic(
	// 	context.data.locationId
	// 		? {
	// 				id: context.data.locationId,
	// 				name: context.data.locationName ?? '',
	// 		  }
	// 		: null
	// );

	// if (!context.data.locationId) {
	// 	track({
	// 		event: 'pageview',
	// 		page_location: '/booking-online/choose-clinic/',
	// 		page_title: 'Booking online - 1 - Choose Clinic',
	// 	});
	// 	// @ts-ignore
	// 	showLocationModal();
	// }

	// return loadChooseServicesPage(context);
}
